<template>
  <div>

    <div style="width: 100%; display: flex; flex-direction: row; justify-content: flex-end; align-items: flex-end;">
        <el-dropdown @command="handleDropdownCommand" v-if="$store.getters.getInventoryMasterDataProps.id>0">
            <el-button size="small" style="margin-right: 20px;">
                Print Barcode<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown" align="left">
                <el-dropdown-item command="printRetailQr">Retail Item Label</el-dropdown-item>
                <el-dropdown-item command="printStockQr">Stock Item Label</el-dropdown-item>                    
            </el-dropdown-menu>
        </el-dropdown>
        <el-button 
        v-if="($store.getters.getInventoryMasterDataProps.id>0 && $store.getters.getAccessRights.can_edit) || ($store.getters.getInventoryMasterDataProps.id === 0 && $store.getters.getAccessRights.can_add)"
        style="margin-right: 5px;" @click="submit" :loading="$store.getters.getLoadingState" type="primary" size="small">Submit</el-button>
        <el-popconfirm
            @confirm="$store.dispatch('deleteInventoryMasterData', {id: $store.state.inventoryMaster.props.id, navBack: true, store_list: $store.getters.getAccessibleStoreList})"
            title="Are you sure to delete this?"
            >
            <el-button v-if="$store.getters.getInventoryMasterDataProps.id>0 && !popup && $store.getters.getAccessRights.can_delete" style="margin-right: 5px;" slot="reference" type="danger" size="small">Delete</el-button>            
        </el-popconfirm>
        
        <el-button size="small" @click="close">Go Back</el-button>
    </div>
    
    <br>
    <PrintWindow 
        :title="getPrintTitle"
        v-if="isPrintWindowVisible"
        :src="getPrintSrc"
        :dialogVisible="isPrintWindowVisible" 
        @closePrintWindow="showPrintWindow = false" />
    
    <el-tabs v-model="activeTab">
        <el-tab-pane label="Basic Info." name="1">
                <Basic />
        </el-tab-pane>
        <el-tab-pane label="Price &amp; Tax" name="2">
            <PriceAndTax />
        </el-tab-pane>   
        <el-tab-pane label="Variant List" name="3">
            <VariantList />
            <!--<br>
            <OtherVariant />-->
        </el-tab-pane>    
        <!--<el-tab-pane v-if="$store.getters.getInventoryMasterDataProps.item_type === 2 
            || ($store.getters.getInventoryMasterDataProps.item_type === 1 
                    && $store.state.inventoryMaster.props.fabric_can_be_sold_as_retail)" 
                    label="e-Store Details" name="4">
            <div style="text-align: left; width: 100%; display: flex; 
            flex-direction: row; justify-content: space-between; align-items: space-between;">
                <el-checkbox v-model="$store.state.inventoryMaster.props.estore_available">
                    Is this product available online?
                </el-checkbox>
                <div >
                    <span type="label">Placement Number</span>
                    <br>
                    <el-input @focus="$event.target.select()"
                        v-model="$store.state.inventoryMaster.props.estore_placement"
                        size="small"
                        type="number"
                        style="width: 200px;">
                    </el-input>
                </div>
                
            </div>
            <br>
            <EStore v-if="$store.state.inventoryMaster.props.estore_available" />
        </el-tab-pane>-->
        <el-tab-pane label="Images" name="5">
            <ImageList />
        </el-tab-pane>    
        <el-tab-pane v-if="$store.getters.getInventoryMasterDataProps.item_type === 4" label="Service Logs" name="6">
            <ServiceLog />
        </el-tab-pane>    
        <el-tab-pane label="Statement" name="7">
            <Statement />
        </el-tab-pane>    
    </el-tabs>

    
    
    <br><br><br><br>
  </div>
</template>

<script>
import Basic from './Basic.vue'
import PriceAndTax from './PriceAndTax.vue'
import VariantList from './VariantList.vue'
import Statement from './Statement.vue'
import ServiceLog from './ServiceLog.vue'
import ImageList from './ImageList'
import EStore from './EStore/Index.vue'
import OtherVariant from './OtherVariant.vue'

export default {
    props: ['popup'],
    components: { OtherVariant, EStore, ImageList, Basic, PriceAndTax, VariantList, Statement, ServiceLog },
    data() {
        return {
            activeTab: '1',
            showPrintWindow: false,
            printSrc: '',
            printTitle: ''
        }
    },
    computed: {
        getPrintTitle() {
            return this.printTitle
        },
        getPrintSrc() {
            return this.printSrc
        },
        isPrintWindowVisible() {
            return this.showPrintWindow
        }
    },
    methods: {
        submit() {
            let payload = JSON.parse(JSON.stringify(this.$store.getters.getInventoryMasterDataProps))
            if(this.popup) {
                payload.popup = true
            }
            if(payload.item_type === 0) {
                this.$store.commit('displayMessageAlert', {message: 'Please select the inventory type', type: 'Error'})    
                return
            } else if(payload.sub_category_id === null || payload.sub_category_id === 0) {
                this.$store.commit('displayMessageAlert', {message: 'Please select the category of this article', type: 'Error'})  
                document.getElementById(payload.sub_category_id).focus()  
                return
            }
            this.$store.dispatch('submitInventoryMasterData', payload)
        },
        handleDropdownCommand(command) {
            if(command === 'printRetailQr') {
                let labelType = this.$store.getters.getInventoryMasterDataProps.item_type === 1 ? 'retail' : 'ready_item'
                this.printSrc = this.master_url+'target=printQrTag&subpage=print&print_type='+labelType+'&item_id='+this.$store.getters.getInventoryMasterDataProps.id+'&access_token='+this.$store.getters.getAccessToken
            } else if(command === 'printStockQr') {
                this.printSrc = this.master_url+'target=printQrTag&subpage=print&print_type=stock&item_id='+this.$store.getters.getInventoryMasterDataProps.id+'&access_token='+this.$store.getters.getAccessToken
            }
            this.printTitle = 'Paper Size: Custom'
            this.showPrintWindow = true            
        },
        close() {
            if(this.popup) {

                let uomName = ""
                let uomIndex = this.$store.getters.getUOMMasterList.findIndex((t) => t.id === this.$store.getters.getInventoryMasterDataProps.unit_of_measurement_id)
                if(uomIndex >=0) {
                    uomName = this.$store.getters.getUOMMasterList[uomIndex].unit_name
                }

                let emitPayload = {
                        id: this.$store.getters.getInventoryMasterDataProps.id,
                        sku_code: this.$store.getters.getInventoryMasterDataProps.sku_code, 
                        article_name: this.$store.getters.getInventoryMasterDataProps.article_name, 
                        unit_name: uomName
                    }
                
                if(this.$store.getters.getInventoryMasterDataProps.id === 0) {
                    this.$confirm('Are you sure to leave this page?', 'Warning', {
                        confirmButtonText: 'OK',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                    }).then(() => {
                        this.$emit('closed', emitPayload)
                        return
                    }).catch(() => {
                        return  
                    });
                } else {
                    this.$emit('closed', emitPayload)
                }

                
            } else {
                this.$router.push(this.$router.currentRoute.fullPath.replace('/form/', ''))
            }
            
        }
    },
    mounted() {
        if(this.$store.getters.getInventoryRackList.length === 0) {
            this.$store.dispatch('fetchInventoryRackList')
        }
        if(this.popup) {
            this.$store.dispatch('fetchEmployeeMasterList', {store_list: this.$store.getters.getAccessibleStoreList})
        }
        this.$store.state.inventoryMaster.statement.list = []
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/InventoryMaster/Form/Index.vue